import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { Context } from 'Context/Context';
import useIsMobile from 'Hooks/useIsMobile';
import { FileClock } from 'lucide-react';

function EmptyCaseList() {
  const { userDetails } = useContext(Context);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  if (isMobile) {
    return (
      <div className="w-full flex flex-col items-center justify-center text-center font-plexsans bg-cream pt-12 px-6 pb-[30px] min-h-[55vh]">
        <div className="font-plexmono font-normal text-[10px] leading-none tracking-[.16em] uppercase text-brass mb-4">
          Welcome, {userDetails?.firstName}
        </div>
        <h1 className="mt-0 mx-0 mb-3.5 font-spectral font-normal text-[27px] leading-[1.25] text-navy">
          Let's create your first case.
        </h1>
        <p className="mt-0 mx-auto mb-[30px] max-w-[30ch] font-plexsans font-normal text-[13.5px] leading-[1.7] text-navy/[.6]">
          A guided intake, about 6 minutes. Identity and case information stays hidden until you approve attorneys to view.
        </p>
        <button
          onClick={() => navigate('/client/createCase')}
          className="w-full rounded-sm cursor-pointer transition-colors min-h-[48px] font-plexsans font-medium text-[14px] leading-none text-ivory bg-brass hover:bg-brassDark border-0 p-4"
        >
          Start my case
        </button>
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col items-center text-center font-plexsans bg-cream pt-16 px-[30px] pb-[74px]">
      <FileClock className="mb-4 w-8 h-8 text-navy/[.3]" strokeWidth={1.4} />
      <p className="mt-0 mx-0 mb-1 font-plexsans font-normal text-[15px] leading-[1.5] text-navy/[.55]">
        You do not have any published cases for attorneys to review.
      </p>
      <p className="m-0 font-plexsans font-normal text-[15px] leading-[1.5] text-navy/[.55]">
        Click <strong className="text-navy font-medium">&quot;Create new case&quot;</strong> to get started.
      </p>
    </div>
  )
}

export default EmptyCaseList
